import React, { useState } from "react";
import "./AddBoardModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { useLanguage } from "../../../LanguageProvider";
import AddModalInputField from "../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../ToasterProvider";

export default function AddBoardModal({ isOpen, onClose, onCreate }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [boardTitle, setBoardTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (boardTitle.trim() === "") {
      toastWarning(getTranslation("boardNameCantBeEmpty"));
      return;
    }
    onCreate(boardTitle);
    onClose();
    setBoardTitle("");
  };

  return (
    <div className="add-board-modal-overlay">
      <div className="add-board-modal-container">
        <IoCloseOutline
          className="add-board-modal-button close"
          onClick={onClose}
        />

        <p className="add-board-modal-title">{getTranslation("addNewBoard")}</p>

        <AddModalInputField icon={<TbStack2 size={22} style={{ width: "25px" }} />} placeholder={getTranslation("enterBoardTitle") + "*"} value={boardTitle} onChange={(e) => setBoardTitle(e.target.value)} type={"text"} />

        <div className="add-board-modal-actions">
          <button
            className="add-board-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
